import type { DirectiveBinding } from 'vue';

import { pushEvent } from '@/utils/utils.js';

export const vGtmTrack = {
  mounted: (el: HTMLElement, binding: DirectiveBinding) => {
    pushEvent({ event: `${binding.arg}_show`, name: `Affichage ${binding.arg}`, label: binding.value.product.id, data: binding.value });
    el.addEventListener('click', () => {
      pushEvent({ event: `${binding.arg}_click`, name: `Clic sur ${binding.arg}`, label: binding.value.product.id, data: binding.value });
    });
  },
  unmounted: (el: HTMLElement, binding: DirectiveBinding) => {
    el.removeEventListener('click', () => {
      pushEvent({ event: `${binding.arg}_click`, name: `Clic sur ${binding.arg}`, label: binding.value.product.id, data: binding.value });
    });
  },
};
